import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  CANCEL_INTERVIEW,
  GET_AVAILABLE_SLOTS,
  GET_JOB_APPLICATION,
  GET_JOB_APPLICATION_DETAILS,
  GET_PROFILE_DETAILS,
  INTERVIEW_APPLY,
  JOB_APPLICATION_TIMELINE,
  VERIFY_ACTION_OTP,
  WITHDRAWN_JOB_APPLICATION,
} from "helpers/url_helper"

export const getJobApplication = createAsyncThunk(
  GET_JOB_APPLICATION,
  async payload => {
    const response = await post(GET_JOB_APPLICATION, payload)
    return response
  }
)
export const getJobApplicationDetails = createAsyncThunk(
  GET_JOB_APPLICATION_DETAILS + "GET DETAIL",
  async uuid => {
    const response = await get(`${GET_PROFILE_DETAILS}/${uuid}`)
    return response
  }
)

export const getAvailableSlots = createAsyncThunk(
  GET_AVAILABLE_SLOTS,
  async () => {
    const response = await get(GET_AVAILABLE_SLOTS)
    return response
  }
)

export const interviewApply = createAsyncThunk(
  INTERVIEW_APPLY,
  async payload => {
    const response = await post(INTERVIEW_APPLY, payload)
    return response
  }
)

export const withdrawnJobApplication = createAsyncThunk(
  WITHDRAWN_JOB_APPLICATION,
  async () => {
    const response = await get(WITHDRAWN_JOB_APPLICATION)
    return response
  }
)

export const cancelInterview = createAsyncThunk(
  CANCEL_INTERVIEW,
  async payload => {
    const response = await post(CANCEL_INTERVIEW, payload)
    return response
  }
)

export const getJobApplicationTimeline = createAsyncThunk(
  JOB_APPLICATION_TIMELINE,
  async () => {
    const response = await get(JOB_APPLICATION_TIMELINE)
    return response
  }
)

export const verifyActionOtp = createAsyncThunk(
  VERIFY_ACTION_OTP,
  async payload => {
    const response = await post(VERIFY_ACTION_OTP, payload)
    return response
  }
)
